<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-slate-800">
      <div class="max-w-[1400px] mx-auto space-y-4">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-4 flex items-center justify-between">
                  <div>
                        <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Access Control Management
                        </h2>
                        <p class="text-[10px] text-slate-500 uppercase font-medium">Map system permissions to security
                              roles</p>
                  </div>

                  <button (click)="openModal()"
                        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-xs font-bold transition-all shadow-sm flex items-center gap-1.5 uppercase">
                        <span class="text-sm">+</span> New Permission
                  </button>
            </div>

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-6">

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div class="space-y-2">
                              <label class="block text-[11px] font-bold text-slate-500 uppercase tracking-wider">Organisation
                                    Context</label>
                              <select [(ngModel)]="selectedOrgId" (change)="onOrgChange()"
                                    class="w-full px-4 py-2 border border-slate-200 rounded-md text-sm bg-slate-50/50 outline-none focus:border-blue-500 transition-all cursor-pointer">
                                    <option value="" disabled>Select Organisation...</option>
                                    <option *ngFor="let org of organisations" [value]="org.id">{{ org.name }}</option>
                              </select>
                        </div>

                        <div class="space-y-2">
                              <label class="block text-[11px] font-bold text-slate-500 uppercase tracking-wider">Target
                                    Role</label>
                              <select [(ngModel)]="selectedRoleId" (change)="loadMapping()"
                                    class="w-full px-4 py-2 border border-slate-200 rounded-md text-sm bg-slate-50/50 outline-none focus:border-blue-500 transition-all font-semibold cursor-pointer">
                                    <option value="" disabled>Select role...</option>
                                    <option *ngFor="let role of filteredRoles" [value]="role.id">{{ role.name }} ({{
                                          role.code }})</option>
                              </select>
                        </div>
                  </div>

                  <div class="flex items-center justify-between mb-4 border-b border-slate-100 pb-3">
                        <h6 class="text-[11px] font-bold text-slate-500 uppercase tracking-widest">Assign Capabilities
                        </h6>
                        <div class="flex gap-2">
                              <button (click)="toggleAll(true)"
                                    class="text-[10px] font-bold text-blue-600 hover:bg-blue-50 px-2 py-1 rounded transition-all uppercase">Select
                                    All</button>
                              <button (click)="toggleAll(false)"
                                    class="text-[10px] font-bold text-slate-400 hover:bg-slate-50 px-2 py-1 rounded transition-all uppercase">Clear</button>
                        </div>
                  </div>

                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        <div *ngFor="let p of permissions" (click)="p.isAssigned = !p.isAssigned"
                              [ngClass]="p.isAssigned ? 'border-blue-200 bg-blue-50/30' : 'border-slate-200 bg-white'"
                              class="group border rounded-md p-3 flex items-start gap-3 transition-all hover:shadow-md cursor-pointer relative overflow-hidden">

                              <div class="pt-0.5">
                                    <input type="checkbox" [(ngModel)]="p.isAssigned" (click)="$event.stopPropagation()"
                                          class="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 cursor-pointer">
                              </div>

                              <div class="flex-1 min-w-0">
                                    <p class="text-xs font-bold text-slate-700 truncate mb-0.5">{{ p.name }}</p>
                                    <p class="text-[9px] font-mono text-slate-400 uppercase tracking-tighter">{{ p.code
                                          }}</p>
                              </div>

                              <div *ngIf="p.isAssigned"
                                    class="absolute top-0 right-0 w-8 h-8 bg-blue-500/10 rounded-bl-full flex items-center justify-center">
                                    <svg class="w-3 h-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                          <path
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
                                    </svg>
                              </div>
                        </div>
                  </div>

                  <div class="mt-8 pt-4 border-t border-slate-100 flex items-center justify-between">
                        <p class="text-[10px] text-slate-400 italic font-medium">Changes will be applied immediately to
                              all users in this role.</p>
                        <div class="flex gap-3">
                              <button
                                    class="px-6 py-2 text-slate-500 hover:text-slate-700 font-bold text-[10px] uppercase tracking-widest transition-all">Discard</button>
                              <button (click)="saveMapping()"
                                    class="bg-slate-900 hover:bg-black text-white px-8 py-2 rounded shadow-lg shadow-slate-200 font-bold text-[10px] uppercase tracking-widest transition-all active:scale-95">
                                    Push Changes
                              </button>
                        </div>
                  </div>
            </div>
      </div>
</div>

<div *ngIf="showModal" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
      <div class="bg-white w-full max-w-md rounded-lg shadow-2xl border border-slate-200 overflow-hidden">
            <div class="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                  <h3 class="text-xs font-bold uppercase tracking-widest text-slate-600">Register New Permission</h3>
                  <button (click)="closeModal()" class="text-slate-400 hover:text-slate-600">&times;</button>
            </div>
            <div class="p-6 space-y-4">
                  <div>
                        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Permission Name</label>
                        <input [(ngModel)]="newPerm.name" type="text" placeholder="e.g. Export Reports"
                              class="w-full px-3 py-2 border border-slate-200 rounded text-sm outline-none focus:border-blue-500">
                  </div>
                  <div>
                        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">System Code</label>
                        <input [(ngModel)]="newPerm.code" type="text" placeholder="e.g. PERM_REPORT_EXPORT"
                              class="w-full px-3 py-2 border border-slate-200 rounded font-mono text-xs uppercase outline-none focus:border-blue-500">
                  </div>
            </div>
            <div class="p-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-2">
                  <button (click)="closeModal()"
                        class="px-4 py-2 text-[10px] font-bold text-slate-500 uppercase">Cancel</button>
                  <button (click)="createPermission()"
                        class="bg-blue-600 text-white px-6 py-2 rounded text-[10px] font-bold uppercase shadow-sm">Save
                        Permission</button>
            </div>
      </div>
</div>